import { mapGetters, mapMutations, mapState } from 'vuex'
import { GENERAL_STORE } from '@apps/order-form/src/store'
import validationMixinGeneral from '@apps/order-form/src/mixins/validationMixinGeneral'

export default {
  mixins: [validationMixinGeneral],

  props: {
    dot: {
      type: Object,
      required: true,
    },
  },

  methods: {
    ...mapMutations(GENERAL_STORE, ['updateDot', 'addValidator']),
  },

  computed: {
    ...mapGetters(GENERAL_STORE, ['isBuyout', 'getDotIndex', 'isYandexForm']),
    ...mapState(GENERAL_STORE, ['order']),
    phone: {
      get() {
        return this.dot.phone
      },
      set(value) {
        this.updateDot({
          dot: this.dot,
          data: {
            key: 'phone',
            value,
          },
        })
      },
    },
    isFirstDot() {
      return this.getDotIndex(this.dot) === 0
    },
  },

  mounted() {
    const phoneValidator = {
      name: `phone-${this.getDotIndex(this.dot)}`,
      touch: () => this.$refs.phoneInput.touchField('phone'),
      hasErrors: () => !this.$refs.phoneInput.isValid,
      elRef: this.$refs.phoneInput.$el,
    }

    this.validators.push(phoneValidator)
    this.addValidator(phoneValidator)
  },
}
